import { useSelector } from 'react-redux';
import { RootState } from '~/store';
import useTranslate from '../useTranslate';
import { logToSentry } from '~/helpers/loggers.helper';
import { notifications } from '@qred/components-library';

const useOpenLink = () => {
  const t = useTranslate();
  const {
    intl: { market },
  } = useSelector((state: RootState) => state);

  return (urlKey: string, sentryErrorName: string): void => {
    const url = t(urlKey) as string;
    if (!url || url === urlKey) {
      logToSentry(
        new Error(`Missing URL for ${urlKey} in market ${market}`),
        sentryErrorName
      );
      notifications.show({
        state: 'critical',
        message: t('SomethingWentWrong'),
        opened: true,
      });
      return;
    }
    window.open(url, '_blank', 'noopener noreferrer');
  };
};

export default useOpenLink;
